function bytesToHex (bytes) {
  const hex = []
  bytes.forEach((b) => hex.push(('0' + b.toString(16)).slice(-2)))
  return hex.join(':')
}

export { bytesToHex }
